/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TCreateCpdDraftRequest, TCreateCpdDraftModel, IMappers, TCreateCpdDraftResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV1CreateCpdDraftResponse } from '../../entities/entities/V1CreateCpdDraftResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createCreateCpdDraftModel(parameters: TCreateCpdDraftRequest): TCreateCpdDraftModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'cpd',
    pathApi: '/v1/create-cpd-draft/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ICreateCpdDraftOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TCreateCpdDraftRequest;
}

export async function fetchCreateCpdDraft<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICreateCpdDraftOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TCreateCpdDraftResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCreateCpdDraftModel(parameters),
    config,
  )) as FetchResponse<TCreateCpdDraftResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV1CreateCpdDraftResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCreateCpdDraftResponse>;
}
